import { useState } from "react";
import { FileText, Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { useAuthedApi, errMsg } from "../lib/api";

// Private files need the auth header, so they are fetched as a blob instead of a plain link.
export function PrivateDocButton({ url, testid = "view-private-doc" }) {
  const api = useAuthedApi();
  const open = async () => {
    try {
      const blob = await api("get", url.replace(/^\/api/, ""), null, { responseType: "blob" });
      window.open(URL.createObjectURL(blob), "_blank");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return <button type="button" onClick={open} className="text-[#E5C158] flex items-center gap-1 text-xs hover:underline" data-testid={testid}><FileText className="w-3 h-3" />View document</button>;
}

export function PrivateDocUpload({ value, onChange, testid = "private-doc" }) {
  const api = useAuthedApi();
  const [busy, setBusy] = useState(false);
  const onFile = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { onChange((await api("post", "/upload?private=true", fd)).url); toast.success("Document uploaded privately"); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <label className="btn-outline !py-1.5 text-xs cursor-pointer">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}{value ? "Replace photo" : "Upload photo"}
        <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" disabled={busy} data-testid={`${testid}-input`} onChange={(e) => { onFile(e.target.files[0]); e.target.value = ""; }} />
      </label>
      {value && <PrivateDocButton url={value} testid={`${testid}-view`} />}
    </div>
  );
}
